import quadVert from './quad.vert.glsl?raw';
import warpVert from './warp.vert.glsl?raw';
import blending from './blending.glsl?raw';
import composite from './composite.frag.glsl?raw';
import view from './view.frag.glsl?raw';
import copy from './copy.frag.glsl?raw';
import brush from './brush.frag.glsl?raw';
import strokeApply from './strokeApply.frag.glsl?raw';
import adjust from './adjust.frag.glsl?raw';
import marchingAnts from './marchingAnts.frag.glsl?raw';
import blur from './blur.frag.glsl?raw';
import blurColor from './blurColor.frag.glsl?raw';
import combine from './combine.frag.glsl?raw';
import alphaToMask from './alphaToMask.frag.glsl?raw';
import strokeFilter from './strokeFilter.frag.glsl?raw';
import smudge from './smudge.frag.glsl?raw';
import region from './region.frag.glsl?raw';
import healJacobi from './healJacobi.frag.glsl?raw';
import healApply from './healApply.frag.glsl?raw';
import gradient from './gradient.frag.glsl?raw';
import channelView from './channelView.frag.glsl?raw';
import maskApply from './maskApply.frag.glsl?raw';
import patternApply from './patternApply.frag.glsl?raw';
import offset from './offset.frag.glsl?raw';
import filterFrag from './filter.frag.glsl?raw';
import liquify from './liquify.frag.glsl?raw';
import liquifyBrush from './liquifyBrush.frag.glsl?raw';
import liquifyFreeze from './liquifyFreeze.frag.glsl?raw';
import maskSample from './maskSample.frag.glsl?raw';
import fxTint from './fxTint.frag.glsl?raw';
import fxStroke from './fxStroke.frag.glsl?raw';
import fxBevel from './fxBevel.frag.glsl?raw';
import fxOverlay from './fxOverlay.frag.glsl?raw';

const VERSION = '#version 300 es\n';
const PRECISION = 'precision highp float;\nprecision highp sampler2D;\n';

/**
 * The `.glsl` files deliberately omit `#version` so that shared chunks such as
 * `blending.glsl` can be concatenated here; Vite has no `#include` support.
 */
function fragment(...chunks: string[]): string {
  return VERSION + PRECISION + chunks.join('\n');
}

export const shaderSources = {
  quadVert: VERSION + quadVert,
  warpVert: VERSION + warpVert,
  composite: fragment(blending, composite),
  view: fragment(view),
  copy: fragment(copy),
  brush: fragment(brush),
  strokeApply: fragment(blending, strokeApply),
  adjust: fragment(adjust),
  marchingAnts: fragment(marchingAnts),
  blur: fragment(blur),
  blurColor: fragment(blurColor),
  combine: fragment(combine),
  alphaToMask: fragment(alphaToMask),
  strokeFilter: fragment(strokeFilter),
  smudge: fragment(smudge),
  region: fragment(region),
  healJacobi: fragment(healJacobi),
  healApply: fragment(healApply),
  gradient: fragment(blending, gradient),
  channelView: fragment(channelView),
  maskApply: fragment(maskApply),
  patternApply: fragment(blending, patternApply),
  offset: fragment(offset),
  filter: fragment(filterFrag),
  liquify: fragment(liquify),
  liquifyBrush: fragment(liquifyBrush),
  liquifyFreeze: fragment(liquifyFreeze),
  maskSample: fragment(maskSample),
  fxTint: fragment(fxTint),
  fxStroke: fragment(fxStroke),
  fxBevel: fragment(fxBevel),
  fxOverlay: fragment(fxOverlay),
} as const;

export type ShaderName = keyof typeof shaderSources;
